export const TOUR_READY = {
  GC_DASHBOARD: "gc-dashboard"
} as const;

export const tourReadySelector = (key: string) => `[data-tour-ready="${key}"]`;

export const TOUR_TARGETS = {
  NAV_SUBMITTALS: "nav-submittals",
  NAV_MATERIALS: "nav-materials",
  NAV_SCHEDULES: "nav-schedules",
  NAV_REPORTS: "nav-reports",
  NAV_SETTINGS: "nav-settings",
  ACTIONS_DUE_2_WEEKS: "actions-due-2-weeks",
  RISK_UPDATES: "risk-updates",
  ALERTS: "alerts",
  PLANNING_DUE: "planning-due"
} as const;

export type TourTargetKey = (typeof TOUR_TARGETS)[keyof typeof TOUR_TARGETS];

export const tourSelector = (key: string) => `[data-tour="${key}"]`;
